import React from 'react';
import ProviderUsageListTable from './ProviderUsageListTable';

const ProviderEditUsageTab = (): JSX.Element => {
    return (
        <div className="provider-edit-usage-tab">
            <ProviderUsageListTable />
        </div>
    );
};

export default ProviderEditUsageTab;
